import SelfServiceReport from "../interfaces/SelfServiceReport";
import ReportsByType from "./interfaces/ReportsByType";

export const filterReportsByQuery = (
  reports: SelfServiceReport[],
  query: string
) =>
  query
    ? reports.filter((r) => r.name.toLowerCase().includes(query.toLowerCase()))
    : reports;

export const separateReportsByType = (
  reports: SelfServiceReport[],
  userId: string
) => {
  const result: ReportsByType = {
    personalReports: [],
    sharedReports: [],
  };

  if (!userId) {
    return result;
  }

  return reports.reduce((acc, val) => {
    if (val.userId === userId) {
      acc.personalReports.push(val);
    } else {
      acc.sharedReports.push(val);
    }
    return acc;
  }, result);
};
